import React from "react";
import {
  PaperClipIcon,
  PaperAirplaneIcon,
  CameraIcon,
  VideoCameraIcon,
  MicrophoneIcon,
  ChevronLeftIcon,
} from "@heroicons/react/24/outline";
import { RiSpeakLine } from "react-icons/ri";
import logo from "../assets/Logo icon.jpg";
import "../CSS/Message.css";

function LiveChat({ setView, setActiveIcon }) {
  return (
    <>
      <div className="mt-4 flex-grow relative">
        <div>
          <ChevronLeftIcon
            onClick={() => {
              setView("LandingWindow");
              setActiveIcon("home");
            }}
            className="w-5 h-5 text-blue-800 absolute left-3 cursor-pointer"
          />
        </div>
        <div className="flex flex-col items-center gap-y-3">
          <div className="text-blue-800 font-semibold text-base">
            Welcome to DexKor
          </div>
          <div>
            <img src={logo} alt="Brand-icon" className="w-12 h-12" />
          </div>
          <div className="text-sm font-semibold">Live Convo</div>
        </div>
      </div>

      {/* <div>
        <div className="dexkor-message-input-container p-0 rounded-lg">
          <div className="dexkor-message-input-options relative flex items-center p-1">
            <input type="file" className="hidden" />
            <button
              type="button"
              className="text-gray-500 hover:text-gray-700 ml-3"
            >
              <PaperClipIcon className="h-4 w-4" />
            </button>
            <button
              type="button"
              className="text-gray-500 hover:text-gray-700 ml-3"
            >
              <CameraIcon className="h-4 w-4" />
            </button>
            <button
              type="button"
              className="text-gray-500 hover:text-gray-700 ml-3"
            >
              <VideoCameraIcon className="h-4 w-4" />
            </button>
          </div>
          <input
            placeholder="Type/record your message..."
            className="flex-1 mt-1 w-full h-auto py-2 px-3 mb-3 border-none text-sm focus:outline-none focus:ring-0  block bg-gray-100"
            rows={1}
          />
          <div className="flex justify-end p-1">
            <button className="bg-transparent pl-0 text-gray-500 hover:text-gray-700">
              <RiSpeakLine className="h-4 w-4" />
            </button>
            <button className="text-gray-500 hover:text-gray-700 ml-2">
              <MicrophoneIcon className="h-4 w-4 text-gray-500" />
            </button>
            <button className="bg-blue-500 text-white p-2 rounded-full ml-2 hover:bg-blue-600">
              <PaperAirplaneIcon className="h-2 w-2" />
            </button>
          </div>
        </div>
      </div> */}

      <div>
        <div className="dexkor-message-input-container p-2 rounded-2xl">
          <input
            placeholder="Type/record your message..."
            className="flex-1 w-full h-auto py-1 px-3 mb-1 border-none text-xs focus:outline-none focus:ring-0 block bg-transparent"
          />

          <div className="flex justify-end items-center space-x-3">
            <button type="button" className="text-gray-500 hover:text-gray-700">
              <PaperClipIcon className="h-4 w-4" />
            </button>
            <button type="button" className="text-gray-500 hover:text-gray-700">
              <CameraIcon className="h-4 w-4" />
            </button>
            <button type="button" className="text-gray-500 hover:text-gray-700">
              <VideoCameraIcon className="h-4 w-4" />
            </button>
            <button className="bg-transparent text-gray-500 hover:text-gray-700">
              <RiSpeakLine className="h-4 w-4" />
            </button>
            <button className="text-gray-500 hover:text-gray-700">
              <MicrophoneIcon className="h-4 w-4" />
            </button>
            <button className="bg-blue-500 text-white p-2 rounded-full hover:bg-blue-600">
              <PaperAirplaneIcon className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default LiveChat;
